<template>
  <section>
    <div class="card">
      <div class="card-header">{{ $t('message.menu.company_address') }}</div>
      <div class="card-body">
        <button
          @click="openUserAddressFormModal(null, null)"
          class="button -cyan">
          {{ $t('message.company_address.add_new_company_address') }}
        </button>
        <div class="table-responsive mt-4" v-if="companies.length > 0">
          <table class="table">
            <thead>
            <tr class="d-flex">
              <th class="col-4">{{ $t('message.company_address.company_customer_name') }}</th>
              <th class="col-6">{{ $t('message.company_address.address') }}</th>
              <th class="col-2">{{ $t('message.company_address.action') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr class="d-flex" v-for="(company, index) in companies" :key="index">
              <td class="col-4">
                <div>{{ company.company }}</div>
                <div class="mt-2">
                  Tax ID: {{ company.tax_id }}
                </div>
                <div class="mt-2">
                  <span class="badge badge-pill badge-light" style="background-color: #E0E0E0;">
                    {{ company.is_company ? $t('message.company_address.juristic_person') : $t('message.company_address.normal_person') }}
                  </span>
                </div>
              </td>
              <td class="col-6">
                {{ getFullAddress(company) }}
              </td>
              <td class="col-2">
                <p>
                  <a href="#" @click.prevent="openUserAddressFormModal(index, company.id)">
                    {{ $t('message.button.edit') }}
                  </a>
                </p>
                <p>
                  <a href="#" @click.prevent="deleteUserCompany(index, company.id)">
                    {{ $t('message.button.delete') }}
                  </a>
                </p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center">
          <button class="button -cyan"
                  :disabled="state.isFetching"
                  @click.prevent="fetchCompanyAddresses"
                  v-if="state.isMore"> {{ $t(isLoadMore) }}
          </button>
        </div>
      </div>
    </div>
    <company-address-modal ref="userCompanyModal"
                           @finished="fetchFirstPage"
                           :manageData="false"
                           :formAction="formAction"/>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import CompanyAddressModal from './CompanyAddressModal'
  import addressHelpers from '../../../helpers/addressHelpers'

  export default {
    components: {
      CompanyAddressModal
    },
    data () {
      return {
        queryData: {
          page: 0,
          user_id: null
        },
        formAction: 'add'
      }
    },
    computed: {
      ...mapGetters({
        isLoadMore: 'companyAddress/isLoadMore',
        globalState: 'globalVal/getState',
        state: 'companyAddress/getState',
        user: 'auth/getUser'
      }),
      ...mapState('companyAddress', [
        'companies',
        'isFetching',
        'isMore',
        'isAdding'
      ])
    },
    watch: {
      companies () {
        this.$refs.userCompanyModal.showUserCompanyModal(false)
      }
    },
    methods: {
      getFullAddress (userCompany) {
        return addressHelpers.getCompanyFullAddress(userCompany)
      },
      fetchFirstPage () {
        this.queryData.page = 0
        this.$store.dispatch('companyAddress/LOAD_COMPANY_ADDRESS', this.queryData)
      },
      fetchCompanyAddresses () {
        this.queryData.page++
        this.$store.dispatch('companyAddress/LOAD_COMPANY_ADDRESS', this.queryData)
      },
      deleteUserCompany (index, id) {
        let detail = this.$i18n.t('message.button.delete') + ' ' + this.$i18n.t('message.company_address.address')

        this.$swal({
          title: this.$i18n.t('message.confirm.title'),
          text: detail,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.confirm.yes'),
          cancelButtonText: this.$i18n.t('message.confirm.cancel')
        }).then(async () => {
          this.$store.commit('companyAddress/SET_SELECTED_INDEX', index)
          await this.$store.dispatch('companyAddress/DELETE_COMPANY', id)
          this.fetchFirstPage()
        })
      },
      openUserAddressFormModal (index, id) {
        this.formAction = (index === null) ? 'add' : 'edit'
        this.$store.commit('companyAddress/SET_SELECTED_INDEX', null)
        // Set empty listing for empty input of adding data
        this.$refs.userCompanyModal.clearFormData()

        // Set selected index for updating data
        this.$store.commit('companyAddress/SET_SELECTED_INDEX', index)
        this.$refs.userCompanyModal.setUserAddressData(index)

        this.$refs.userCompanyModal.showUserCompanyModal(true)
        this.$store.commit('companyAddress/SET_ADDING_STATUS', false)
      }
    },
    mounted () {
      this.queryData.user_id = this.user.id
      this.$store.dispatch('companyAddress/LOAD_COMPANY_ADDRESS', this.queryData)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/companyAddress/Index.vue